














































































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import railwayInterface from '../interface/railway';
import railwayInfoInterface from '../interface/railwayInfo';
import userInterface from '../interface/user';
import Railway from './Railway.vue';
import City from './City.vue';
import ModalWindow from '../ModalWindow/ModalWindow.vue';
import BuildWay from '../Game/BuildWay.vue';
import ChooseColorForMulti from '../Game/ChooseColorForMulti.vue';
import BuildStation from '../Game/BuildStation.vue';
import DenyStation from '../Game/DenyStation.vue';
import typeOfCardsColor from '../interface/colorType';
import taskInterface from '../interface/taskInterface';
// import citiesInfo from '../../store/game/citiesInfo';
import ICity from '../interface/ICity';

@Component({
  computed: {
    ...mapGetters([
      'getRailways',
      'getUsers',
      'getRailwaysInfo',
      'getUsers',
      'getTurn',
      'getTurnWeight',
      'getTurnToEnd',
      'getCurrentName',
      'getCurrentTasks',
      'getCities',
    ]),
  },

  components: {
    Railway,
    City,
    ModalWindow,
    BuildWay,
    BuildStation,
    DenyStation,
    ChooseColorForMulti,
  },
})
export default class Map extends Vue {
  @Prop({ default: [] }) private visibleCities!: string[];

  getRailways!: railwayInterface[];

  getRailwaysInfo!: railwayInfoInterface[];

  getCities!: ICity[];

  getTurn!: number;

  getTurnToEnd!: number;

  getUsers!: userInterface[];

  getCurrentName!: string;

  getTurnWeight!: number;

  path!: string;

  city!: number;

  showBuildWayModal = false;

  showChooseColorForMulti = false;

  showStationChooseRoute = false;

  showDenyStations = false;

  getCurrentTasks!: taskInterface[];

  chosenColorForMulti: typeOfCardsColor = 'loco';

  // citiesInfo = citiesInfo;

  get checkLastTurn(): boolean {
    return this.getTurnToEnd - this.getTurn < this.getUsers.length;
  }

  get currentUser(): userInterface | undefined {
    return this.getUsers.find((u) => u.name === this.getCurrentName);
  }

  get checkActive(): boolean {
    if (this.getTurn === -1) return false;
    return this.getUsers[this.getTurn % this.getUsers.length].name === this.getCurrentName;
  }

  pickWay(e: MouseEvent): void {
    if (this.checkActive && this.getTurnWeight === 0) {
      if (e.target instanceof Element) {
        const target = e.target.closest('.route') || e.target.closest('.city-point');
        if (target) {
          if (target.classList.contains('route')) {
            this.path = target.getAttribute('data-path') || '';
            if (this.path) {
              const currentRoute = this.getRailwaysInfo.find((route) => route.id === this.path);
              if (currentRoute) {
                if (currentRoute.color !== 'multi') {
                  this.showBuildWayModal = true;
                } else {
                  this.showChooseColorForMulti = true;
                }
              } else {
                console.log('Error: cant find this route in base');
              }
            } else {
              console.log('Error: wrong path');
            }
          } else {
            this.city = Number(target.getAttribute('data-city')) || -1;
            if (this.city) {
              const currentCity = this.getCities.find((city) => city.id === this.city);
              if (this.currentUser?.hand.stations === 0) {
                this.showDenyStations = true;
              } else if (currentCity) {
                this.showStationChooseRoute = true;
              }
            }
          }
        }
      }
    }
  }

  buildMultiWay(color: typeOfCardsColor): void {
    this.chosenColorForMulti = color;
    this.showBuildWayModal = true;
  }
}
